export default function getStreamCDNPublicUrl(path) {
  if (!path) return null;
  return `https://stream-cdn.nightco.io/${path.startsWith("/") ? path.slice(1) : path}`;
}
export function getStreamProtectedCDNPublicUrl(path) {
  if (!path) return null;
  return `https://protected-cdn.nightco.io/${path.startsWith("/") ? path.slice(1) : path}`;
}